(function() {
    'use strict';

    var GenerateRetainerInvoiceCtrl = function($scope, $compile, $uibModalInstance, ajaxCall, passedModel, xmsNotificationFactory) {

        console.log("Inside GenerateRetainerInvoiceCtrl");

        if( !angular.isDefined(passedModel) ){
            passedModel = {}; // otherwise any ng-init inside modal will create the model in it's own child scope (inaccessible)
        }

        console.log("INSIDE GenerateRetainerInvoiceCtrl");
        $scope.stage2InvoiceModel = passedModel;

       $scope.fnGenerateInvoice = function($event) {
            console.log("INSIDE fnGenerateInvoice");
            $event.preventDefault();
            var ajaxUrl = WEBAPP_PATH + "/item/submitStage2Invoice?";
            var data = $scope.stage2InvoiceModel;
            console.log(data)
            ajaxCall.getData(ajaxUrl, data).then(
                function(result) {
                    xmsNotificationFactory.addObj({id: "stage2InvoicePop", type: result.data.responseType, bodyHtml: result.data.responseMessage, timeout:10});
                    $uibModalInstance.close($scope.stage2InvoiceModel);
                },
                function(result) {
                    var alertMessage = "Error occurred. Please try again later..";
                    xmsNotificationFactory.addObj({id: "stage2InvoicePop", type: "danger", bodyHtml: alertMessage, timeout:10});
                    $uibModalInstance.close($scope.stage2InvoiceModel);
                }
            );
            $event.preventDefault();
        }

        $scope.cancelPop = function($event) {
            $event.preventDefault();
            $uibModalInstance.dismiss('cancel');
        }

        $scope.cancel = function() {
           $uibModalInstance.dismiss('cancel');
        }


    }
    GenerateRetainerInvoiceCtrl.$inject = ['$scope', '$compile', '$uibModalInstance','ajaxCall','params','xmsNotificationFactory'];
    angular.module('app').controller('GenerateRetainerInvoiceCtrl', GenerateRetainerInvoiceCtrl);

}());